<template>
  <div class="page">
    <h2>提交记录</h2>
    <div class="toolbar">
      <input v-model="keyword" placeholder="搜索（社员号/姓名等）" />
      <input v-model="startDate" type="date" />
      <input v-model="endDate" type="date" />
      <button @click="search">查询</button>
      <button class="primary" @click="exportExcel">导出 Excel</button>
      <router-link :to="`/dashboard/forms/${formId}/edit`">返回表单</router-link>
    </div>
    <table v-if="rows.length" class="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>提交时间</th>
          <th v-for="col in columns" :key="col.key">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.id">
          <td>{{ row.id }}</td>
          <td>{{ formatTime(row.submittedAt) }}</td>
          <td v-for="col in columns" :key="col.key">{{ cell(row, col.key) }}</td>
        </tr>
      </tbody>
    </table>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-else-if="!rows.length" class="empty">暂无数据</p>
    <div class="pager">
      <button :disabled="page <= 0" @click="page--; load()">上一页</button>
      <span>第 {{ page + 1 }} 页</span>
      <button :disabled="!hasNext" @click="page++; load()">下一页</button>
    </div>
  </div>
</template>

<script>
import { formService } from '@/services/formService'

export default {
  name: 'FormSubmissions',
  data() {
    return {
      formId: this.$route.params.id,
      keyword: '',
      startDate: '',
      endDate: '',
      page: 0,
      size: 20,
      rows: [],
      columns: [],
      fields: [],
      hasNext: false,
      error: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    formatTime(v) {
      return String(v || '').replace('T', ' ').slice(0, 19)
    },
    cell(row, key) {
      const v = row.answers?.[key]
      if (Array.isArray(v)) return v.join('、')
      return v ?? ''
    },
    search() {
      this.page = 0
      this.load()
    },
    async load() {
      this.error = ''
      const params = { page: this.page, size: this.size, keyword: this.keyword || undefined }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      try {
        const [res, formRes] = await Promise.all([
          formService.listSubmissions(this.formId, params),
          this.fields.length ? Promise.resolve(null) : formService.getForm(this.formId)
        ])
        if (formRes?.success && formRes.data) {
          this.fields = formRes.data.fields || []
        }
        if (!res.success || !res.data) {
          this.rows = []
          this.columns = []
          this.error = res.message || '查询失败'
          return
        }
        this.rows = res.data.content || []
        this.hasNext = !res.data.last
        const labelByKey = new Map(this.fields.map(field => [field.fieldKey, field.label]))
        const keys = this.fields.map(field => field.fieldKey)
        this.rows.forEach(row => {
          Object.keys(row.answers || {}).forEach(key => {
            if (!keys.includes(key)) keys.push(key)
          })
        })
        this.columns = keys.map(key => ({ key, label: labelByKey.get(key) || key }))
      } catch (e) {
        this.rows = []
        this.columns = []
        this.error = e.response?.data?.message || '查询失败，请稍后重试'
      }
    },
    async exportExcel() {
      const params = { keyword: this.keyword || undefined }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      const res = await formService.exportSubmissions(this.formId, params)
      const blob = res.data instanceof Blob ? res.data : res
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `form-${this.formId}-submissions.xlsx`
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.page { padding: 24px; }
.toolbar { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 16px; }
.toolbar .primary { background: #409eff; color: #fff; border: none; padding: 6px 12px; border-radius: 4px; }
.table { width: 100%; border-collapse: collapse; font-size: 13px; }
.table th, .table td { border: 1px solid #eee; padding: 6px 8px; }
.pager { margin-top: 12px; display: flex; gap: 12px; align-items: center; }
.empty { color: #999; }
.error { color: #e54d42; }
</style>
